module.exports = __webpack_public_path__ + "img/STERiGLIDE_03.9277e042.jpg";